import Placeholder from "../../../assets/placeholder.png";
import Check from "../../../assets/check.png";

const ReviewUsers: React.FC<any> = () => {

  return (
    <section>
      <div className="items-center flex-col lg:flex-row lg:gap-x-10 xl:gap-x-16 bg-[#262626] planoBackgroundCor2 justify-between py-[54px] relative bg-x60light-gray gap-y-10 px-8 md:px-16 xl:px-40 2xl:px-72 sm:w-auto">
        <div className="flex flex-col gap-y-8 flex-1 grow" style={{ display: 'flex', alignItems: 'center' }}>
          <div>
            <p className="[font-family:'Poppins-ExtraBold',Helvetica] font-extrabold text-transparent text-4xl tracking-[0.80px] leading-[normal]">
              <span className="text-neutral-800 text-white">Review das </span>
              <span className="text-[black]">participantes</span>
            </p>
          </div>
          <div>
            <p className="w-full [font-family:'Poppins-ExtraBold',Helvetica] text-base text-justify leading-6">
              <span className="[font-family:'Poppins-Regular',Helvetica]">
                Com acesso exclusivo a dicas de todas as cidades, eventos imperdíveis, classificados úteis e o <b>Radar Solidário</b>, você também conta com <b>descontos especiais, networking empresarial e oportunidades de viagens</b> incríveis. Um universo de vantagens feito para mulheres empresárias que buscam crescer com suporte, praticidade e <b>conexões de valor!</b>
              </span>
            </p>
          </div>
        </div>

        <br />
        <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
          <div className="relative inline-block px-2 xl:px-4 whitespace-normal modoMobilePlanoReview" >
            <div className="nc-CardAuthorBox2 flex flex-col overflow-hidden bg-white dark:bg-neutral-800 rounded-3xl shadow-lg mb-5"
              style={{ height: '285px' }}>
              <div className="relative flex-shrink-0 " style={{ padding: '12px', background: '#303030', display: 'flex' }}>
                <div className="flex" style={{ height: '35px', width: '35px' }}>
                  <img
                    className="w-full h-40 md:h-60 lg:h-80 2xl:h-96"
                    src={Check}
                    style={{ height: "100%", borderRadius: '50%' }}
                    onError={(e: any) => {
                      e.target.onerror = null; // Previne um loop infinito no caso de falha ao carregar a imagem alternativa
                      e.target.src = Placeholder; // Substitua pela URL da imagem alternativa
                    }}
                  />
                </div>
                <div>
                  <div style={{ color: '#836749' }}>
                    &nbsp; Jane Vendrame
                  </div>
                  <div style={{ color: 'white', fontSize: '12px', position: 'relative', top: '-8px' }}>
                    &nbsp; @janevendrame
                  </div>
                </div>
              </div>
              <div className="m-8 text-center">
                Radar, passou a ser uma ferramente de ajuda e uma net love. Lugar onde pessoas tem o mesmo propósito, ajudar e ser ajudado. Não poderia ser mais perfeito.
              </div>
            </div>
          </div>

          <div className="relative inline-block px-2 xl:px-4 whitespace-normal modoMobilePlanoReview">
            <div className="nc-CardAuthorBox2 flex flex-col overflow-hidden bg-white dark:bg-neutral-800 rounded-3xl shadow-lg mb-5"
              style={{ height: '285px' }}>
              <div className="relative flex-shrink-0 " style={{ padding: '12px', background: '#303030', display: 'flex' }}>
                <div className="flex" style={{ height: '35px', width: '35px' }}>
                  <img
                    className="w-full h-40 md:h-60 lg:h-80 2xl:h-96"
                    src={Check}
                    style={{ height: "100%", borderRadius: '50%' }}
                    onError={(e: any) => {
                      e.target.onerror = null; // Previne um loop infinito no caso de falha ao carregar a imagem alternativa
                      e.target.src = Placeholder; // Substitua pela URL da imagem alternativa
                    }}
                  />
                </div>
                <div>
                  <div style={{ color: '#836749' }}>
                    &nbsp; Jane Vendrame
                  </div>
                  <div style={{ color: 'white', fontSize: '12px', position: 'relative', top: '-8px' }}>
                    &nbsp; @janevendrame
                  </div>
                </div>
              </div>
              <div className="m-8 text-center">
                Radar, passou a ser uma ferramente de ajuda e uma net love. Lugar onde pessoas tem o mesmo propósito, ajudar e ser ajudado. Não poderia ser mais perfeito.
              </div>
            </div>
          </div>

          <div className="relative inline-block px-2 xl:px-4 whitespace-normal modoMobilePlanoReview" >
            <div className="nc-CardAuthorBox2 flex flex-col overflow-hidden bg-white dark:bg-neutral-800 rounded-3xl shadow-lg mb-5"
              style={{ height: '285px' }}>
              <div className="relative flex-shrink-0 " style={{ padding: '12px', background: '#303030', display: 'flex' }}>
                <div className="flex" style={{ height: '35px', width: '35px' }}>
                  <img
                    className="w-full h-40 md:h-60 lg:h-80 2xl:h-96"
                    src={Check}
                    style={{ height: "100%", borderRadius: '50%' }}
                    onError={(e: any) => {
                      e.target.onerror = null; // Previne um loop infinito no caso de falha ao carregar a imagem alternativa
                      e.target.src = Placeholder; // Substitua pela URL da imagem alternativa
                    }}
                  />
                </div>
                <div>
                  <div style={{ color: '#836749' }}>
                    &nbsp; Jane Vendrame
                  </div>
                  <div style={{ color: 'white', fontSize: '12px', position: 'relative', top: '-8px' }}>
                    &nbsp; @janevendrame
                  </div>
                </div>
              </div>
              <div className="m-8 text-center">
                Radar, passou a ser uma ferramente de ajuda e uma net love. Lugar onde pessoas tem o mesmo propósito, ajudar e ser ajudado. Não poderia ser mais perfeito.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section >
  );
};

export default ReviewUsers;
